import { ReactElement } from 'react';
import { RenderEditCellProps } from 'components/DataGrid';
import type { Supplier } from 'modules/supplier/supplier/types';

import { useEntity } from 'components';
import { BlockDetails } from 'modules/campaign/block/types';

import { trapEnterHandler } from 'components/DataGrid/editors/utils';

import { SupplierPicker } from 'modules/supplier/supplier/components/SupplierPicker';
import { GridRow } from 'modules/campaign/plan/types';
import { usePlanMutations } from 'modules/campaign/plan/state';
import { resolveSupplierPatch } from './resolveSupplierPatch';

type Props = Pick<RenderEditCellProps<GridRow, any>, 'row' | 'onClose'>;

export function EditSupplier({ row, onClose }: Props): ReactElement {
  // FIXME: this should use DialogEditor but would have to take SupplierSelector apart
  const value = row.supplier;
  const { type, id: for_block } = useEntity<BlockDetails>().item;
  const update = usePlanMutations().update;

  const onChange = async (supplier: Supplier | null): Promise<void> => {
    const result = await resolveSupplierPatch(row, supplier);
    if (result.kind === 'dismissed') {
      // modal cancelled — keep the editor open so the user can pick again
      return;
    }
    if (result.kind === 'noop') {
      onClose(false, true);
      return;
    }
    const res = await update({ rows: { upsert: [result.patch] } });
    res.unwrap();

    onClose(false, true);
  };
  return (
    <div onKeyDown={trapEnterHandler}>
      <SupplierPicker
        value={value}
        type={type}
        kind={row.kind}
        onRequestClose={() => onClose(false, true)}
        onChange={onChange}
        for_block={for_block}
      />
    </div>
  );
}
